var map = {
	"./Prophets/Amos.json": 1843,
	"./Prophets/Ezekiel.json": 3786,
	"./Prophets/Habakkuk.json": 3819,
	"./Prophets/Haggai.json": 6020,
	"./Prophets/Hosea.json": 421,
	"./Prophets/Isaiah.json": 1488,
	"./Prophets/Jeremiah.json": 1220,
	"./Prophets/Joel.json": 5905,
	"./Prophets/Jonah.json": 3311,
	"./Prophets/Joshua.json": 5105,
	"./Prophets/Judges.json": 4271,
	"./Prophets/Kings1.json": 1728,
	"./Prophets/Kings2.json": 9805,
	"./Prophets/Malachi.json": 5880,
	"./Prophets/Micah.json": 2719,
	"./Prophets/Nahum.json": 9956,
	"./Prophets/Obadiah.json": 9339,
	"./Prophets/Samuel1.json": 8655,
	"./Prophets/Samuel2.json": 4862,
	"./Prophets/Zechariah.json": 8876,
	"./Prophets/Zephaniah.json": 5937,
	"./Torah/Deuteronomy.json": 1999,
	"./Torah/Exodus.json": 5726,
	"./Torah/Genesis.json": 9030,
	"./Torah/Leviticus.json": 5398,
	"./Torah/Numbers.json": 4142,
	"./Writings/Chronicles1.json": 2126,
	"./Writings/Chronicles2.json": 6495,
	"./Writings/Daniel.json": 4330,
	"./Writings/Ecclesiastes.json": 71,
	"./Writings/Esther.json": 3702,
	"./Writings/Ezra.json": 7891,
	"./Writings/Job.json": 8688,
	"./Writings/Lamentations.json": 4568,
	"./Writings/Nehemiah.json": 2884,
	"./Writings/Proverbs.json": 8522,
	"./Writings/Psalms.json": 229,
	"./Writings/Ruth.json": 6064,
	"./Writings/SongOfSongs.json": 9853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5874;